import styled from 'styled-components';
import C from '@assets/themes/colors';
import D from '@assets/themes/dimensions';

export const Root = styled.div`
  width: ${D.TOOL_BAR_WIDTH}px;
  flex-grow: 1;
  flex-direction:column;
  background-color: #0f1318;
  
  padding: 5px 0px 5px 0px;
  box-sizing: border-box;
  align-items: flex-start;
`;